import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CookieConsentSelection, CookieConsentService } from '../../../core/services/cookie-consent.service';

@Component({
  selector: 'app-cookie-consent-banner',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: '',
  styles: []
})
export class CookieConsentBannerComponent {
  draft: CookieConsentSelection = {
    analytics: false,
    marketing: false,
    preferences: false
  };

  constructor(public readonly cookieConsentService: CookieConsentService) {}

  preparePreferences(): void {
    const consent = this.cookieConsentService.consent();
    this.draft = {
      analytics: consent?.analytics ?? this.cookieConsentService.isCategoryEnabled('analytics'),
      marketing: consent?.marketing ?? false,
      preferences: consent?.preferences ?? this.cookieConsentService.isCategoryEnabled('preferences')
    };
    this.cookieConsentService.openPreferences();
  }

  savePreferences(): void {
    this.cookieConsentService.saveCustom(this.draft);
  }
}
